module.exports = __webpack_public_path__ + "media/in_house/guide-6a843001.png";